import moment from 'moment';

export const formatDate = (date: moment.MomentInput) =>
  date ? moment(date).format('lll') : '';
